import styled from "@emotion/styled";

import { COLORS } from "shared/config/constants";

/** Layout tokens from Downloads/CPN - Deal Summary/Blocked Applicant Queue.dc.html (5a–5c). */
export const ApplicantMeta = styled.div`
  font-size: 17px;
  font-weight: 300;
  line-height: 1.3;
  color: ${COLORS.textColorSecondary};
  margin-top: 12px;

  strong {
    font-weight: 500;
    color: ${COLORS.textColorPrimary};
  }
`;

export const Intro = styled.p`
  font-family: "Work Sans", sans-serif;
  font-size: 15px;
  font-weight: 400;
  line-height: 1.55;
  color: #2d2943;
  margin: 0 0 24px;
  text-wrap: pretty;
`;

export const FieldBlock = styled.div`
  margin-bottom: 20px;
`;

export const NoteBlock = styled.div`
  margin-bottom: 24px;
`;

export const FieldLabel = styled.label`
  display: block;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: ${COLORS.textColorSecondary};
  margin-bottom: 8px;
`;

export const RequiredMark = styled.span`
  color: ${COLORS.failedRed};
  text-transform: uppercase;
  letter-spacing: 0.04em;
`;

export const OptionalMark = styled.span`
  font-weight: 400;
  text-transform: none;
  letter-spacing: 0;
`;

export const Helper = styled.div`
  font-size: 13px;
  line-height: 1.5;
  color: ${COLORS.textColorSecondary};
  margin-top: 6px;
`;

export const HelperWarn = styled(Helper)`
  color: #b35500;
`;

/** Disabled Yardi reason state from mock 5c. */
export const UnavailableYardiField = styled.div`
  &.yardi-unavailable {
    .ant-select-selection {
      height: 40px;
      border: 1px solid #dedce5;
      border-radius: 2px;
      background: #f9fafc;
    }

    .ant-select-selection__rendered {
      margin: 0 35px 0 11px;
      line-height: 38px;
    }

    .ant-select-selection__placeholder {
      color: #b2afc8;
      font-size: 15px;
    }

    .ant-select-arrow {
      opacity: 0.4;
    }
  }
`;

export const YardiBanner = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  background: ${COLORS.background};
  border-radius: 2px;
  padding: 12px 14px;
  margin-bottom: 24px;
  font-size: 13px;
  line-height: 1.5;
  color: ${COLORS.textColorSecondary};

  strong {
    font-weight: 500;
    color: ${COLORS.textColorPrimary};
  }
`;

export const YardiBannerIcon = styled.div`
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  display: flex;
  border-radius: 2px;
  overflow: hidden;

  svg,
  img {
    width: 20px;
    height: 20px;
    display: block;
  }
`;

export const YardiBannerText = styled.div`
  flex: 1;
  min-width: 0;
`;

export const WarningRow = styled.div`
  display: flex;
  align-items: center;
  background: ${COLORS.well.backgroundLightError};
  border-radius: 2px;
  padding: 16px;
  margin-bottom: 24px;
`;

export const WarningIconWrap = styled.div`
  margin-right: 24px;
  display: flex;
  flex-shrink: 0;

  svg,
  img {
    width: 40px;
    height: 40px;
    display: block;
  }
`;

export const WarningText = styled.p`
  font-size: 15px;
  line-height: 1.55;
  color: ${COLORS.textColorPrimary};
  margin: 0;
`;

export const NoteArea = styled.div`
  textarea {
    min-height: 72px;
  }
`;
